import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import bccy1 from '../imagenes/logo1.svg';

function NavbarHolding() {
  const [click, setClick] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = click ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [click]);

  const navClass = scrolled ? 'navbar navbar--scrolled' : 'navbar';
  const menuClass = click ? 'nav-menu active' : 'nav-menu';

  return (
    <nav className={navClass}>
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
          <img src={bccy1} className="navbar-logo-image" alt="BCCY Colombia Holding" />
        </Link>

        <button type="button" className="menu-icon" onClick={handleClick} aria-label="Menu">
          <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
        </button>

        <ul className={menuClass}>
          <li className="nav-item">
            <Link to="/" className="nav-links" onClick={closeMobileMenu}>
              Inicio
            </Link>
          </li>

          <li className="nav-item">
            <Link to="/contacth" className="nav-links" onClick={closeMobileMenu}>
              Contáctenos
            </Link>
          </li>
        </ul>

        <div
          className={click ? 'nav-backdrop show' : 'nav-backdrop'}
          onClick={closeMobileMenu}
        />
      </div>
    </nav>
  );
}

export default NavbarHolding;